import React, { Fragment, useCallback, useEffect, useState } from 'react'
import DataTable from 'react-data-table-component';
import { Spinner } from '../../../../AbstractElements';
import { Button, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Input, Label, Media, Row, UncontrolledDropdown } from 'reactstrap';
import { MoreVertical, PlusCircle } from 'react-feather';
import CommonModal from '../../../UiKits/Modals/common/modal'
import axios from 'axios';
import moment from 'moment';
import { spinnerData } from './data';
import Swal from 'sweetalert2'
import { baseURL,imageURL } from '../../../../Services/api/baseURL';
import dummyImg from '../../../../assets/images/product/2.png';
import { Image } from '../../../../AbstractElements';
import { FaPen } from 'react-icons/fa';
import Loader from '../../../Loader/Loader';
import useRbac from '../../../../Hooks/useRbac';
import Select from 'react-select';


const GroupTagsTable = () => {
    const { can } = useRbac();
    const [selectedRows, setSelectedRows] = useState([]);
    const [toggleDelet, setToggleDelet] = useState(false);

    const [searchTerm, setSearchTerm] = useState('');
    const [AddModal, SetAddmodal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false)
    const [groupTagData, setGroupTagData] = useState([])
    const [editData, setEditData] = useState(null)
    const [groupTagName, setGroupTagName] = useState()
    const [groupTagImage, setGroupTagImage] = useState(null)
    const [imagePreview, setImagePreview] = useState(null)
    const [categoryOptions, setCategoryOptions] = useState([])
    const [selectedCategories, setSelectedCategories] = useState([])
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [loading, setLoading] = useState(false);

    const AddMOdalToggle = () => {
        SetAddmodal(!AddModal)
        setEditData(null)
        setGroupTagName()
        setGroupTagImage(null)
        setImagePreview(null)
        setSelectedCategories([])
    };

    const fetchCategories = async () => {
        const token = await JSON.parse(localStorage.getItem("token"))
        try {
            const res = await axios.get(`${baseURL}/api/admin/get-collections?page=1&limit=1000`, {
                headers: {
                    Authorization: `${token}`
                }
            })
            setCategoryOptions((res.data.data || []).map(c => ({ value: c._id, label: c.collection_name })));
        } catch (error) {
            console.log(error)
        }
    }

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setGroupTagImage(file);
            setImagePreview(URL.createObjectURL(file));
        }
    };

    const handleSearch = (event) => {
        event.preventDefault();
        setSearchTerm(event.target.value);
    };

    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);

    const fetchGroupTags = async (page) => {
        const token = await JSON.parse(localStorage.getItem("token"))
        try {
            const stores = await axios.get(`${baseURL}/api/admin/get-group-tags?page=${page}&limit=${perPage}`, {
                headers: {
                    Authorization: `${token}`
                }
            })
            setGroupTagData(stores.data.data);
            setTotalRows(stores.data.total);
        } catch (error) {
            console.log(error)
        }
    }

    const handlePageChange = (page) => {
        fetchGroupTags(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        setLoading(true);

        const token = await JSON.parse(localStorage.getItem("token"))
        try {
            const res = await axios.get(`${baseURL}/api/admin/get-group-tags?page=${page}&limit=${newPerPage}`, {
                headers: {
                    Authorization: `${token}`,
                }
            })
            setGroupTagData(res.data.data)
            setPerPage(newPerPage);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    };

    const postGroupTag = async () => {
        const token = await JSON.parse(localStorage.getItem("token"))
        try {
            const formData = new FormData();
            formData.append('group_tag_name', groupTagName);
            formData.append('categories', JSON.stringify(selectedCategories.map(c => c.value)));
            if (groupTagImage) {
                formData.append('Image', groupTagImage);
            }
            await axios.post(`${baseURL}/api/admin/add-group-tag`, formData, {
                headers: {
                    Authorization: `${token}`,
                    'Content-Type': 'multipart/form-data',
                }
            })
            fetchGroupTags(1);
            SetAddmodal(!AddModal)
            Swal.fire({
                title: "Group Tag Added!",
                icon: "success",
                confirmButtonColor: "#d3178a",
            });
        } catch (error) {
            Swal.fire({
                title: error?.response?.data?.message,
                icon: "error",
                confirmButtonColor: "#d3178a",
            });
            console.log(error)
        }
    }

    const editGroupTag = async (id) => {
        const token = await JSON.parse(localStorage.getItem("token"))
        try {
            const formData = new FormData();
            formData.append('group_tag_name', groupTagName);
            formData.append('categories', JSON.stringify(selectedCategories.map(c => c.value)));
            if (groupTagImage) {
                formData.append('Image', groupTagImage);
            }

            await axios.patch(`${baseURL}/api/admin/update-group-tag/${id}`, formData, {
                headers: {
                    Authorization: `${token}`,
                    'Content-Type': 'multipart/form-data',
                }
            })
            fetchGroupTags(1)
            SetAddmodal(!AddModal)
            Swal.fire({
                title: "Updated Group Tag!",
                icon: "success",
                confirmButtonColor: "#d3178a",
            });
        } catch (error) {
            Swal.fire({
                title: error?.response?.data?.message,
                icon: "error",
                confirmButtonColor: "#d3178a",
            });
            console.log(error)
        }
    }

    useEffect(() => {
        fetchGroupTags(1);
        fetchCategories();
    }, [])

    const handleEditUpdate = () => {
        if (editData !== null) {
            editGroupTag(editData._id)
        } else {
            postGroupTag()
        }
    }

    const inactiveItem = async () => {
        const token = await JSON.parse(localStorage.getItem("token"))
        try {
            const obj = {
                status: editData.status === "inactive" ? "active" : 'inactive'
            }

            await axios.patch(`${baseURL}/api/admin/update-group-tag-status/${editData._id}`, obj, {
                headers: {
                    Authorization: `${token}`,
                }
            })

            fetchGroupTags(1)
            setDeleteModal(!deleteModal)
        }
        catch (err) {
            console.log(err)
        }
    }

    const orderColumns = [
        {
            name: 'Image',
            sortable: false,
            center: true,
            selector: row => (
                        <>
                            <Media className='d-flex'>
                                <Image attrImage={{ className: ' img-30', src: `${row?.image ? imageURL + row.image : dummyImg}`, alt: ' Image' }} />
        
                            </Media>
                        </>
                    ),
            // cell: (row) => (
            //     row.image ? (
            //         <img
            //             src={row.image.startsWith('http') ? row.image : `${imageURL}/${row.image}`}
            //             alt={row.group_tag_name}
            //             style={{ width: '40px', height: '40px', objectFit: 'cover', borderRadius: '6px' }}
            //         />
            //     ) : (
            //         <p>-</p>
            //     )
            // )
        },
        {
            name: 'Group Tag Name',
            selector: row => row['group_tag_name'],
            sortable: true,
            center: true,
            cell: (row) => (
                row.group_tag_name
            )
        },
        {
            name: 'Categories',
            sortable: false,
            center: true,
            wrap: true,
            cell: (row) => (
                <p>{row?.categories?.length ? row.categories.map(c => c?.collection_name).filter(Boolean).join(', ') : '-'}</p>
            )
        },
        {
            name: 'Added By',
            selector: row => row?.added_by?.first_name,
            sortable: true,
            center: true,
            cell: (row) => (
                <p>{row?.added_by?.first_name || '-'}</p>
            )
        },
        {
            name: 'Status',
            selector: row => `${row.status}`,
            sortable: true,
            center: true,
            cell: (row) => (
                <p className={`text-${row.status === "inactive" ? "[#ff0000]" : "[#008800]"}`}>{row.status === "active" ? "Active" : "In-Active"}</p>
            )
        },
        {
            name: 'Created Date',
            selector: row => `${row.createdAt}`,
            cell: (row) => (
                <p>{moment(row.createdAt).format('DD/MM/YYYY')}</p>
            ),
            sortable: true,
            center: true,
        },
        {
            name: 'Actions',
            omit: !can('group_tags.update'),
            cell: (row) => (
                <UncontrolledDropdown className='action_dropdown'>
                    <DropdownToggle className='action_btn'>
                        <MoreVertical color='#000' size={16} />
                    </DropdownToggle>
                    <DropdownMenu>
                        <DropdownItem onClick={() => {
                            setEditData(row)
                            setGroupTagName(row.group_tag_name)
                            setGroupTagImage(null)
                            setImagePreview(row.image ? imageURL + row.image : dummyImg)
                            setSelectedCategories((row.categories || []).filter(c => c?._id).map(c => ({ value: c._id, label: c.collection_name })))
                            SetAddmodal(!AddModal)
                        }}>
                            Edit
                            <FaPen />
                        </DropdownItem>
                        <DropdownItem
                            onClick={() => {
                                setEditData(row)
                                setDeleteModal(!deleteModal)
                            }}>
                            Change Status
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>
            ),
            sortable: false,
            center: true,
        }
    ]

    const filteredGroupTags = groupTagData.filter(item =>
        item?.group_tag_name?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <Fragment>
            <Row xxl={12} className='pb-4'>
                <div className='d-flex justify-content-between align-items-center'>
                    <h5 className="fw-bolder">Group Tag List</h5>
                    <div className="file-content">
                        <Media>
                            <div className='mb-0 form-group position-relative search_outer d-flex align-items-center'>
                                <i className='fa fa-search'></i>
                                <input className='form-control border-0' value={searchTerm} onChange={(e) => handleSearch(e)} type='text' placeholder='Search...' />
                            </div>
                            {
                                can('group_tags.create') && <Media body className='text-end ms-3'>
                                    <Button className='btn btn-primary d-flex align-items-center' onClick={AddMOdalToggle}>
                                        <PlusCircle />
                                        Add Group Tag
                                    </Button>
                                </Media>
                            }
                        </Media>
                    </div>
                </div>
            </Row>

            {
                groupTagData.length !== 0 ? (
                    <DataTable
                        data={filteredGroupTags || []}
                        columns={orderColumns}
                        center={true}
                        pagination
                        onSelectedRowsChange={handleRowSelected}
                        clearSelectedRows={toggleDelet}
                        progressPending={loading}
                        paginationServer
                        progressComponent={<Loader />}
                        paginationTotalRows={totalRows}
                        onChangeRowsPerPage={handlePerRowsChange}
                        onChangePage={handlePageChange}
                    />
                ) : (
                    <>
                        {
                            spinnerData.map((spinner) =>
                                <Col xxl="12" key={spinner.id} className='flex justify-center items-center'>
                                    <div className="loader-box">
                                        <Spinner attrSpinner={{ className: spinner.spinnerClass }} />
                                    </div>
                                </Col>
                            )
                        }
                    </>
                )
            }

            <CommonModal isOpen={AddModal} className="store_modal" title={editData !== null ? "Update Group Tag" : "Add Group Tag"} toggler={AddMOdalToggle} size="md">
                <Container>
                    <Form>
                        <Col xxl={12}>
                            <FormGroup>
                                <Label className='font-medium text-base'>Group Tag Name</Label>
                                <Input value={groupTagName} onChange={(e) => setGroupTagName(e.target.value)} placeholder='Enter Group Tag Name' />
                            </FormGroup>
                        </Col>
                        <Col xxl={12}>
                            <FormGroup>
                                <Label className='font-medium text-base'>Image</Label>
                                <Input type='file' accept='image/*' onChange={handleImageChange} />
                                {
                                    imagePreview && (
                                        <img
                                            src={imagePreview}
                                            alt='preview'
                                            style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '6px', marginTop: '10px' }}
                                        />
                                    )
                                }
                            </FormGroup>
                        </Col>
                        <Col xxl={12}>
                            <FormGroup>
                                <Label className='font-medium text-base'>Categories</Label>
                                <Select
                                    isMulti
                                    options={categoryOptions}
                                    value={selectedCategories}
                                    onChange={(selected) => setSelectedCategories(selected || [])}
                                    placeholder='Select Categories'
                                    closeMenuOnSelect={false}
                                />
                            </FormGroup>
                        </Col>

                        <Row>
                            <Col md={12} xxl={12} className='modal_btm d-flex justify-content-end'>
                                {/* <Button className="cancel_Btn" onClick={() => SetAddmodal(false)}>
                                    Cancel
                                </Button> */}
                                <Button onClick={handleEditUpdate} className='cursor-pointer mt-3 bg-[#ff0000] font-medium px-2 py-2 rounded-2xl text-white flex justify-center items-center'>
                                    {editData !== null ? "Update Group Tag" : "Save Group Tag"}
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Container>
            </CommonModal>
            <CommonModal isOpen={deleteModal} title="" toggler={() => { setDeleteModal(!deleteModal) }} size="md">
                <Container className='flex flex-col justify-center items-center'>
                    <p>Do You Want To Change Status Of This Group Tag? </p>
                    <div className='flex flex-row space-x-8'>
                        <div onClick={() => setDeleteModal(!deleteModal)} className='border-1 border-[#ff0000] px-2 py-2 text-[#ff0000] rounded-xl cursor-pointer'>Cancel</div>
                        <div onClick={inactiveItem} className='bg-[#ff0000] px-4 py-2 text-white rounded-xl cursor-pointer'>Yes</div>
                    </div>
                </Container>
            </CommonModal>
        </Fragment>
    )
}
export default GroupTagsTable